export enum BackgroundTheme {
  red = 'red',
  blue = 'blue',
  black = 'black',
  white = 'white',
  grey = 'grey',
}
